import { TableData } from 'utils/data'
import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'

export const fetchPayrollOvertimeData = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/payroll/overtime`,
)
